import { n8nApiSlice } from "../../../services/api";
import { USER_PERMISSION_CONFIG } from "../data/userPermissionConfig";
import { IUserPermission } from "../types";

export const userPermissionApi = n8nApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserPermissions: builder.query<IUserPermission[], void>({
            // HOTFIX: 暫時停用 n8n API 調用，使用靜態配置資料
            queryFn: async () => {
                // 模擬 API 延遲
                await new Promise((resolve) => setTimeout(resolve, 100));
                return { data: USER_PERMISSION_CONFIG };
            },
            providesTags: ["n8n_UserPermission"],
        }),
    }),
});

export const { useGetUserPermissionsQuery } = userPermissionApi;
